export class SupportsOfRefundRequestInvoiceItem {
    constructor(
        public codSoporte: string,
        public nombreSoporte: string,
        public cantidadDocumentosPermitidos: number,
        public nombresSoportesAdjuntos: String[]
    ){
        this.nombresSoportesAdjuntos = [];
    }
}


// WEBPACK FOOTER //
// /app/src/app/shared/models/supports-of-request-refund-invoice-item.model.ts